import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AppContext } from './AppContext';

function PublicRoute({ children }) {
  const { getToken } = useContext(AppContext);
  const token = getToken();

  // If user is already authenticated, redirect to dashboard
  if (token) {
    return <Navigate to="/" replace />;
  }

  // Otherwise, render the public page (login, register, etc.)
  return children;
}

export default PublicRoute;